import { css } from "@emotion/css";
import { Callout } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import DeleteDialogLayout from "~/components/Dialog/DeleteDialogLayout";
import { PlatformHubTemplateType } from "./platformHubHelpers";
interface StopShareTemplateDialogProps {
    onSave: (sharedSpaces: SharedSpaces) => Promise<void>;
    onClose: () => void;
    templateType: PlatformHubTemplateType;
}
export interface SharedSpaces {
    shareToAll: boolean;
    individualSpacesSharedTo: string[];
    constraintExceptionSpaceIds: string[];
}
export function StopShareTemplateDialog({ onSave, onClose, templateType }: StopShareTemplateDialogProps) {
    return (<div className={styles.container}>
            <DeleteDialogLayout title={"Stop sharing this template?"} onDeleteClick={async () => {
            await onSave({ shareToAll: false, individualSpacesSharedTo: [], constraintExceptionSpaceIds: [] });
            return true;
        }} deleteButtonLabel={"Stop sharing"} deleteButtonBusyLabel={"Updating..."} onClose={onClose} renderContent={() => (<div className={styles.content}>
                        <Callout type={"warning"} title={`This could affect ${templateType === PlatformHubTemplateType.ProcessTemplate ? "deployment processes" : "projects"} in spaces using this template.`}></Callout>
                        <span>Existing releases can still be run using this template, but it can't be included in new releases or {templateType === PlatformHubTemplateType.ProcessTemplate ? "deployment processes" : "projects"}.</span>
                    </div>)}/>
        </div>);
}
const styles = {
    content: css({
        display: "flex",
        flexDirection: "column",
        gap: space[8],
    }),
    container: css({
        margin: space[24],
    }),
};
